import { BASE_URL_ONLINE_DOCS } from '../../base/constants/cgi-base';
// 获取通知中心未读数
export var NOTIFY_GETNUM = "".concat(BASE_URL_ONLINE_DOCS, "notify_getnum");
// 拉取通知中心记录列表
export var NOTIFY_LIST = "".concat(BASE_URL_ONLINE_DOCS, "notify_list");
// 权限申请审批
export var AUTH_SET = "".concat(BASE_URL_ONLINE_DOCS, "auth_set");
// check审批状态
export var AUTH_APPLY_CHECK = "".concat(BASE_URL_ONLINE_DOCS, "auth_apply/check");
// 删除审批
export var NOTIFY_DELETE = "".concat(BASE_URL_ONLINE_DOCS, "notify_delete");
// 同意文档转让
export var TRANSOWNER_ACCEPT = "".concat(BASE_URL_ONLINE_DOCS, "transowner_accept");
// 拒绝文档转让
export var TRANSOWNER_REJECT = "".concat(BASE_URL_ONLINE_DOCS, "transowner_reject");
